import "core-js/stable";
import "regenerator-runtime/runtime";
import "../../static/proto/css/main.css";
import Vue from "vue";
import store from "./store";
import router from "./router";
import axios from "axios";
import AppComponent from "./app-component.vue";
import "./assets/facebook.js";
import VDatePicker from "v-calendar";
import moment from "moment";
Vue.prototype.moment = moment;

import "vue2-timepicker/dist/VueTimepicker.css";
axios.interceptors.response.use(
    response => {
        return response;
    },
    function(error) {
        console.log(error);
        if (typeof error.response === "undefined") {
            //window.location = '/error/connection-lost'
        }
        if (error.response.status === 401) {
            window.location = "/app/login";
        }
        if (error.response.status === 403) {
            window.location = "/app/login";
        }
        return Promise.reject(error.response);
    }
);

let xsrf_token_meta = document.querySelector('meta[name="_token"]');
axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest"
};

axios.defaults.withCredentials = true;
if (xsrf_token_meta) {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = xsrf_token_meta.getAttribute("content");
    axios.defaults.headers.common["X-Xsrftoken"] = xsrf_token_meta.getAttribute("content");
}

Vue.use(VDatePicker, {
    componentPrefix: "v"
});

window.get_argument = function(name) {
    var location, result;
    location = window.location.search.toLowerCase();
    result = decodeURIComponent((RegExp(name + "=" + "(.*?)(&|$)").exec(location) || ["", ""])[1]);
    if (typeof result === "undefined") {
        result = "";
    }
    return result;
};

window.validate_email = function(email) {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return email != null && email && re.test(email);
};

window.validate_password = function(password) {
    return password && password.length >= 12;
};

Vue.filter("formatSum", function(nr, decimal_places = 0) {
    if (decimal_places == null) {
        decimal_places = 2;
    }
    if (nr && nr.replace != null) {
        nr = nr.replace(",", ".");
        nr = nr.replace(" ", "");
        nr = nr * 1;
    } else if (!nr) {
        nr = 0;
    }
    if (isNaN(nr)) {
        return "0,00";
    } else {
        return nr.toFixed(decimal_places, " ", ",");
    }
});

Vue.filter("formatDate", function(value, full_year = false) {
    if (value) {
        if (full_year) {
            return moment(String(value)).format("DD.MM.YYYY");
        } else {
            return moment(String(value)).format("DD.MM.YY");
        }
    } else {
        return null;
    }
});
Vue.filter("formatNewDate", function(value) {
    if (value) {
        return new Date(value);
    } else {
        return null;
    }
});

let vueapp = new Vue({
    store,
    router,
    template: "<AppComponent/>",
    components: { AppComponent }
}).$mount("#app");

export default vueapp;
